import { render, staticRenderFns } from "./ViewShowTabelaSensorVirtualMensal.vue?vue&type=template&id=34e2e30e&scoped=true&"
import script from "./ViewShowTabelaSensorVirtualMensal.vue?vue&type=script&lang=js&"
export * from "./ViewShowTabelaSensorVirtualMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2e30e",
  null
  
)

export default component.exports